import { Container } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import LoadingCircular from '../../components/default/LoadingCircular'

const Content = () => {
  return (
    <Container maxWidth={false} sx={{ mt: 2 }}>
      <Suspense fallback={<LoadingCircular />}>
        <Outlet />
      </Suspense>
    </Container>
  )
}

export default Content
